import { createFileRoute } from "@tanstack/react-router";
import { BusinessReviewPage } from "@/features/businessreview/BusinessReviewPage";

export const Route = createFileRoute("/_app/reviews/$client/$quarter")({ component: Page });

function Page() {
  const { client, quarter } = Route.useParams();
  return <BusinessReviewPage slug={client} quarter={quarter} />;
}
